(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content-new-layout"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-mb-apple-gallery]');
    if (!root) return;

    const viewport = root.querySelector('[data-mb-viewport]');
    const scroller = root.querySelector('[data-mb-scroller]');
    const slides = Array.from(root.querySelectorAll('[data-mb-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-mb-dot]'));
    const prevBtn = root.querySelector('[data-mb-prev]');
    const nextBtn = root.querySelector('[data-mb-next]');
    const videoTrigger = root.querySelector('[data-video-trigger]');

    const zoom = document.querySelector('[data-mb-zoom]');
    const zoomImg = zoom?.querySelector('[data-mb-zoom-img]');
    const zoomClosers = Array.from(zoom?.querySelectorAll('[data-mb-zoom-close]') || []);
    const zoomPrevBtn = zoom?.querySelector('[data-mb-zoom-prev]');
    const zoomNextBtn = zoom?.querySelector('[data-mb-zoom-next]');
    const zoomCounter = zoom?.querySelector('[data-mb-zoom-counter]');
    const zoomCloseBtn = zoom?.querySelector('button[data-mb-zoom-close]');

    if (!viewport || !scroller || !slides.length) return;

    if (zoom) zoom.setAttribute('hidden', 'true');
    if (zoomImg) zoomImg.removeAttribute('src');

    let index = 0;
    let isDragging = false;
    let startX = 0;
    let lastX = 0;
    let startTranslatePx = 0;
    let moved = 0;

    function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }

    function getW() {
      return viewport?.getBoundingClientRect().width || 1;
    }

    function syncVideoTrigger(i) {
      if (!videoTrigger) return;

      if (i === 0) {
        videoTrigger.removeAttribute('hidden');
      } else {
        videoTrigger.setAttribute('hidden', 'true');
      }
    }

    function setDotFollower(i) {
      const activePos = ((i % 3) + 3) % 3;

      dots.forEach((dot, pos) => {
        const isActive = pos === activePos;

        dot.classList.toggle('is-current', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function setAria(i) {
      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === i ? 'false' : 'true');
      });

      setDotFollower(i);
      syncVideoTrigger(i);
    }

    function updateButtons(i) {
      if (!prevBtn || !nextBtn) return;

      prevBtn.disabled = i <= 0;
      nextBtn.disabled = i >= slides.length - 1;
    }

    function translateTo(i, animate = true) {
      index = clamp(i, 0, slides.length - 1);

      const xPx = Math.round(-index * getW());
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      scroller.style.transition = animate && !prefersReduced
        ? 'transform 850ms cubic-bezier(0.16, 1, 0.3, 1)'
        : 'none';

      scroller.style.transform = `translate3d(${xPx}px, 0, 0)`;

      setAria(index);
      updateButtons(index);
    }

    translateTo(0, false);

    dots.forEach((btn) => {
      btn.addEventListener('click', () => {
        const pos = parseInt(btn.getAttribute('data-dotpos') || '1', 10);

        if (pos === 0) translateTo(index - 1, true);
        if (pos === 1) translateTo(index, true);
        if (pos === 2) translateTo(index + 1, true);
      });
    });

    prevBtn?.addEventListener('click', () => translateTo(index - 1, true));
    nextBtn?.addEventListener('click', () => translateTo(index + 1, true));

    function getClientX(event) {
      if (event.touches && event.touches[0]) return event.touches[0].clientX;
      return event.clientX;
    }

    function getClientY(event) {
      if (event.touches && event.touches[0]) return event.touches[0].clientY;
      return event.clientY;
    }

    let startY = 0;
    let isHorizontalSwipe = false;
    let isVerticalScroll = false;

    function onDown(event) {
      if (event.target.closest('[data-video-trigger]')) return;
      if (event.target.closest('[data-mb-prev], [data-mb-next], [data-mb-dot]')) return;

      isDragging = true;
      isHorizontalSwipe = false;
      isVerticalScroll = false;
      moved = 0;

      startX = getClientX(event);
      startY = getClientY(event);
      lastX = startX;
      startTranslatePx = Math.round(-index * getW());

      scroller.style.transition = 'none';
    }

    function onMove(event) {
      if (!isDragging) return;

      const x = getClientX(event);
      const y = getClientY(event);
      const dx = x - startX;
      const dy = y - startY;

      const absX = Math.abs(dx);
      const absY = Math.abs(dy);

      if (!isHorizontalSwipe && !isVerticalScroll) {
        if (absY > 8 && absY > absX) {
          isVerticalScroll = true;
          isDragging = false;
          translateTo(index, true);
          return;
        }

        if (absX > 8 && absX > absY) {
          isHorizontalSwipe = true;
        }
      }

      if (!isHorizontalSwipe) return;

      moved = Math.max(moved, absX);
      lastX = x;

      let px = startTranslatePx + dx;

      if (index === 0 && dx > 0) {
        px = startTranslatePx + dx * 0.35;
      }

      if (index === slides.length - 1 && dx < 0) {
        px = startTranslatePx + dx * 0.35;
      }

      scroller.style.transform = `translate3d(${Math.round(px)}px, 0, 0)`;
      event.preventDefault?.();
    }

    function onUp() {
      if (!isDragging) return;

      isDragging = false;

      if (!isHorizontalSwipe) {
        translateTo(index, true);
        return;
      }

      const dx = lastX - startX;
      const w = getW();
      const threshold = Math.max(40, w * 0.12);

      if (dx > threshold) {
        translateTo(index - 1, true);
      } else if (dx < -threshold) {
        translateTo(index + 1, true);
      } else {
        translateTo(index, true);
      }
    }

    viewport.addEventListener('mousedown', onDown);
    viewport.addEventListener('mousemove', onMove);
    viewport.addEventListener('mouseup', onUp);
    viewport.addEventListener('mouseleave', onUp);

    viewport.addEventListener('touchstart', onDown, { passive: true });
    viewport.addEventListener('touchmove', onMove, { passive: false });
    viewport.addEventListener('touchend', onUp);
    viewport.addEventListener('touchcancel', onUp);

    window.addEventListener('resize', () => {
      translateTo(index, false);
      syncVideoTrigger(index);
    });

    let zoomIndex = 0;
    let zoomTargetIndex = 0;
    let zoomNavigationRequest = 0;
    let zoomAnimations = [];
    let zoomOutgoing = null;
    let zoomReturnFocus = null;
    let previousPageOverflow = '';
    let zoomTouch = null;
    let zoomGestureMoved = false;
    let suppressZoomClickUntil = 0;

    function isZoomOpen() {
      return zoom && !zoom.hasAttribute('hidden');
    }

    function getZoomSlide(nextIndex) {
      const slideEl = slides[nextIndex];
      if (!slideEl) return null;

      const src =
        slideEl.getAttribute('data-zoom-src') ||
        slideEl.querySelector('img')?.getAttribute('data-zoom-src') ||
        slideEl.querySelector('img')?.currentSrc ||
        slideEl.querySelector('img')?.src ||
        '';

      const alt =
        slideEl.getAttribute('data-zoom-alt') ||
        slideEl.querySelector('img')?.alt ||
        '';

      return src ? { src, alt } : null;
    }

    function clearZoomAnimation() {
      zoomAnimations.forEach((animation) => animation.cancel());
      zoomAnimations = [];
      zoomOutgoing?.remove();
      zoomOutgoing = null;
    }

    function showZoomSlide(nextIndex, direction = 0) {
      if (!zoom || !zoomImg) return false;
      const media = getZoomSlide(nextIndex);
      if (!media) return false;

      const outgoingTransform = getComputedStyle(zoomImg).transform;
      const incomingTransform = zoomOutgoing?.getAttribute('src') === media.src
        ? getComputedStyle(zoomOutgoing).transform : null;
      clearZoomAnimation();
      const animate = direction !== 0 && isZoomOpen() && zoomImg.complete && zoomImg.naturalWidth > 0 &&
        typeof zoomImg.animate === 'function' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (animate) {
        zoomOutgoing = zoomImg.cloneNode(false);
        zoomOutgoing.removeAttribute('data-mb-zoom-img');
        zoomOutgoing.setAttribute('data-mb-zoom-outgoing', '');
        zoomOutgoing.setAttribute('aria-hidden', 'true');
        zoomOutgoing.alt = '';
        zoomImg.parentElement.appendChild(zoomOutgoing);
      }

      zoomIndex = nextIndex;
      zoomImg.src = media.src;
      zoomImg.alt = media.alt;

      if (animate) {
        const distance = zoom.clientWidth * direction;
        const timing = { duration: 850, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'both' };
        const outgoing = zoomOutgoing;
        zoomAnimations = [
          outgoing.animate([
            { transform: outgoingTransform === 'none' ? 'translate3d(0, 0, 0)' : outgoingTransform },
            { transform: `translate3d(${-distance}px, 0, 0)` }
          ], timing),
          zoomImg.animate([
            { transform: incomingTransform || `translate3d(${distance}px, 0, 0)` },
            { transform: 'translate3d(0, 0, 0)' }
          ], timing)
        ];
        Promise.all(zoomAnimations.map((animation) => animation.finished)).then(() => {
          if (zoomOutgoing === outgoing) clearZoomAnimation();
        }).catch(() => {}); // A new navigation or closing the popup cancels the previous transition.
      }

      if (zoomPrevBtn) {
        zoomPrevBtn.hidden = slides.length < 2;
        zoomPrevBtn.disabled = slides.length < 2;
      }
      if (zoomNextBtn) {
        zoomNextBtn.hidden = slides.length < 2;
        zoomNextBtn.disabled = slides.length < 2;
      }
      if (zoomCounter) {
        zoomCounter.hidden = slides.length < 2;
        zoomCounter.textContent = `${zoomIndex + 1} / ${slides.length}`;
        zoomCounter.setAttribute('aria-label', `Image ${zoomIndex + 1} of ${slides.length}`);
      }
      return true;
    }

    function openZoomFromSlide(slideEl) {
      const nextIndex = slides.indexOf(slideEl);
      if (nextIndex < 0 || !showZoomSlide(nextIndex)) return;
      zoomTargetIndex = nextIndex;
      zoomNavigationRequest += 1;

      if (!isZoomOpen()) {
        zoomReturnFocus = root.contains(document.activeElement) ? document.activeElement : slideEl;
        previousPageOverflow = document.documentElement.style.overflow;
      }
      zoomTouch = null;
      zoomGestureMoved = false;
      suppressZoomClickUntil = 0;
      zoom.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      zoomCloseBtn?.focus({ preventScroll: true });
    }

    async function navigateZoom(direction) {
      if (!isZoomOpen() || slides.length < 2) return;

      const nextIndex = (zoomTargetIndex + direction + slides.length) % slides.length;
      const media = getZoomSlide(nextIndex);
      if (!media) return;
      zoomTargetIndex = nextIndex;
      const request = ++zoomNavigationRequest;

      // Keep the current photo visible until the next enlarged photo is ready.
      const incoming = new Image();
      incoming.src = media.src;
      try {
        await incoming.decode();
      } catch {
        if (!incoming.naturalWidth) {
          if (request === zoomNavigationRequest) zoomTargetIndex = zoomIndex;
          return;
        }
      }
      if (request !== zoomNavigationRequest || !isZoomOpen()) return;
      if (nextIndex !== zoomIndex && showZoomSlide(nextIndex, direction)) {
        translateTo(nextIndex, false);
      }
    }

    function closeZoom() {
      if (!isZoomOpen() || !zoomImg) return;

      zoom.setAttribute('hidden', 'true');
      zoomNavigationRequest += 1;
      zoomTargetIndex = zoomIndex;
      clearZoomAnimation();
      zoomImg.removeAttribute('src');
      zoomTouch = null;
      document.documentElement.style.overflow = previousPageOverflow;
      const focusTarget = slides[index] || zoomReturnFocus;
      focusTarget?.focus({ preventScroll: true });
    }

    zoomPrevBtn?.addEventListener('click', () => navigateZoom(-1));
    zoomNextBtn?.addEventListener('click', () => navigateZoom(1));

    // A swipe changes images only at normal page zoom; pinch and panning stay native.
    zoom?.addEventListener('touchstart', (event) => {
      if (!isZoomOpen()) return;
      if (event.touches.length !== 1) {
        zoomTouch = null;
        zoomGestureMoved = true;
        suppressZoomClickUntil = Date.now() + 500;
        return;
      }
      zoomGestureMoved = false;
      suppressZoomClickUntil = 0;
      if (event.target.closest('button')) {
        zoomTouch = null;
        return;
      }
      if ((window.visualViewport?.scale || 1) > 1.01) {
        zoomTouch = null;
        zoomGestureMoved = true;
        suppressZoomClickUntil = Date.now() + 500;
        return;
      }
      const touch = event.touches[0];
      zoomTouch = { id: touch.identifier, x: touch.clientX, y: touch.clientY, horizontal: false, moved: false };
    }, { passive: true });

    zoom?.addEventListener('touchmove', (event) => {
      if (!zoomTouch) return;
      if (event.touches.length !== 1 || (window.visualViewport?.scale || 1) > 1.01) {
        zoomTouch = null;
        zoomGestureMoved = true;
        suppressZoomClickUntil = Date.now() + 500;
        return;
      }
      const touch = event.touches[0];
      const dx = touch.clientX - zoomTouch.x;
      const dy = touch.clientY - zoomTouch.y;
      if (Math.max(Math.abs(dx), Math.abs(dy)) > 10) {
        zoomTouch.moved = true;
        zoomGestureMoved = true;
        suppressZoomClickUntil = Date.now() + 500;
        if (!zoomTouch.horizontal && Math.abs(dy) > Math.abs(dx)) {
          zoomTouch = null;
          return;
        }
        zoomTouch.horizontal = true;
      }
      if (zoomTouch?.horizontal && event.cancelable) event.preventDefault();
    }, { passive: false });

    zoom?.addEventListener('touchend', (event) => {
      if (zoomGestureMoved && !event.touches.length) {
        suppressZoomClickUntil = Date.now() + 500;
        zoomGestureMoved = false;
      }
      if (!zoomTouch) return;
      const gesture = zoomTouch;
      zoomTouch = null;
      if (gesture.moved) suppressZoomClickUntil = Date.now() + 500;
      if (event.touches.length || (window.visualViewport?.scale || 1) > 1.01) return;
      const touch = Array.from(event.changedTouches).find((item) => item.identifier === gesture.id);
      if (!touch) return;
      const dx = touch.clientX - gesture.x;
      const dy = touch.clientY - gesture.y;
      const threshold = Math.max(40, Math.min(80, window.innerWidth * 0.12));
      if (gesture.horizontal && Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy) * 1.25) {
        navigateZoom(dx < 0 ? 1 : -1);
      }
    }, { passive: true });

    zoom?.addEventListener('touchcancel', () => {
      zoomTouch = null;
      zoomGestureMoved = false;
      suppressZoomClickUntil = Date.now() + 500;
    }, { passive: true });

    // Prevent the synthetic click after a swipe from closing the backdrop.
    zoom?.addEventListener('click', (event) => {
      if (event.detail === 0 || Date.now() >= suppressZoomClickUntil) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    viewport.addEventListener('click', (event) => {
      if (event.target.closest('[data-video-trigger]')) return;
      if (event.target.closest('[data-mb-prev], [data-mb-next], [data-mb-dot]')) return;
      if (moved > 8) return;

      const img = event.target.closest('.mb-apple-gallery__image');
      if (!img) return;

      openZoomFromSlide(slides[index]);
    });

    zoomClosers.forEach((el) => {
      el.addEventListener('click', closeZoom);
    });

    document.addEventListener('keydown', (event) => {
      if (!isZoomOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeZoom();
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        navigateZoom(event.key === 'ArrowLeft' ? -1 : 1);
      } else if (event.key === 'Tab') {
        const controls = Array.from(zoom.querySelectorAll('button:not([disabled]):not([hidden])'));
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (!first) return;
        if (!controls.includes(document.activeElement)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    document.addEventListener('variant:selected', function (event) {
      const optionId = event.detail?.resource?.id;
      const selectedOption = document.querySelector(`[data-option-value-id="${optionId}"]`);

      if (!selectedOption) return;

      const variantId = selectedOption.getAttribute('data-variant-id');
      const variantImageUrl = selectedOption.getAttribute('data-variant_image_url');

      if (variantId) {
        let targetIndex = -1;

        slides.forEach((slide, slideIndex) => {
          const ids = slide.getAttribute('data-variant-ids')?.split(',') || [];

          if (ids.includes(variantId)) {
            targetIndex = slideIndex;
          }
        });

        if (targetIndex !== -1) {
          translateTo(targetIndex, true);
        }
      }

      if (variantImageUrl) {
        const activeSlide = slides[index];
        const img = activeSlide?.querySelector('img');

        if (img) {
          img.src = variantImageUrl;
          img.srcset = '';
        }
      }
    });

    const modal = document.querySelector('.product-video-modal');

    if (modal) {
      const close = modal.querySelector('.mb-pro-video-close');
      const overlay = modal.querySelector('.video-overlay');
      const video = modal.querySelector('video');

      if (video) {
        video.playsInline = true;
        video.setAttribute('playsinline', '');
      }

      const openModal = (event) => {
        const trigger = event.target.closest('[data-video-trigger]');
        if (!trigger) return;

        event.preventDefault();
        modal.removeAttribute('hidden');

        if (video) {
          video.load();

          const playAttempt = video.play();

          if (playAttempt && typeof playAttempt.catch === 'function') {
            playAttempt.catch(() => {
              video.muted = true;
              video.setAttribute('muted', '');
              video.play().catch(() => {});
            });
          }
        }
      };

      const closeModal = () => {
        modal.setAttribute('hidden', 'true');

        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      };

      document.addEventListener('click', openModal);
      document.addEventListener('touchend', openModal, { passive: false });

      close?.addEventListener('click', closeModal);
      overlay?.addEventListener('click', closeModal);
    }

    syncVideoTrigger(index);
  });
  } catch(e) { console.error(e); }
})();

})();
